import { slicedToArray as _slicedToArray, toConsumableArray as _toConsumableArray } from '../../../../../_virtual/_rollupPluginBabelHelpers.mjs';
import { jsx, jsxs } from 'react/jsx-runtime';
import React__default from 'react';
import { getLocalYYYYMMDD } from '../../../utils.mjs';
import { useCalendarContext } from '../../context/calendarProvider.mjs';
import { useCalendarEventContext } from '../../context/eventProvider.mjs';
import { ItemWidth, Container, ScrollContainer, LoadMoreContainer, LoadMoreChip, PlusIcon } from './styled.mjs';

var LoadMoreDateCount = 14;
var DayAndWeekIndicator = function DayAndWeekIndicator(_ref) {
  var DateItemCreator = _ref.DateItemCreator;
  var _useCalendarContext = useCalendarContext(),
    currentDateTimestamp = _useCalendarContext.currentDateTimestamp,
    selectedDateValue = _useCalendarContext.selectedDateValue,
    setSelectedDateValue = _useCalendarContext.setSelectedDateValue;
  var _useCalendarEventCont = useCalendarEventContext(),
    overviewEventOnCalendar = _useCalendarEventCont.overviewEventOnCalendar;
  var scrollRef = React__default.useRef(null);
  var _React$useState = React__default.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isInitialized = _React$useState2[0],
    setIsInitialized = _React$useState2[1];
  var _React$useState3 = React__default.useState([]),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    dates = _React$useState4[0],
    setDates = _React$useState4[1];
  var currentDate = React__default.useMemo(function () {
    return new Date(currentDateTimestamp);
  }, [currentDateTimestamp]);
  var selectedDate = React__default.useMemo(function () {
    return selectedDateValue ? new Date(selectedDateValue) : currentDate;
  }, [currentDate, selectedDateValue]);
  // 스크롤 이벤트 처리
  var handleScroll = React__default.useCallback(function () {
    if (!scrollRef.current) return;
    var _scrollRef$current = scrollRef.current,
      scrollLeft = _scrollRef$current.scrollLeft,
      clientWidth = _scrollRef$current.clientWidth;
    // // 스크롤이 멈추면 중앙에 있는 날짜 선택
    clearTimeout(scrollRef.current.scrollTimeout);
    scrollRef.current.scrollTimeout = setTimeout(function () {
      var leftSideLoaderWidth = innerWidth * 0.5;
      var center = scrollLeft + clientWidth / 2;
      var centerIndex = Math.round(Math.abs(leftSideLoaderWidth - center) / ItemWidth) - 1; // -1 for adjust value
      if (dates[centerIndex]) {
        setSelectedDateValue(dates[centerIndex].valueOf());
      }
    }, 150);
  }, [dates, setSelectedDateValue]);
  var handleLoadBefore = React__default.useCallback(function () {
    if (scrollRef.current) {
      var previousScrollLeft = scrollRef.current.scrollLeft;
      setDates(function (prev) {
        var firstIndexDate = prev[0];
        var dateArray = [];
        for (var i = -LoadMoreDateCount; i < 0; i++) {
          var date = new Date(firstIndexDate);
          date.setDate(date.getDate() + i);
          dateArray.push(date);
        }
        requestAnimationFrame(function () {
          if (scrollRef.current) {
            var adjustable = selectedDate.valueOf() === firstIndexDate.valueOf() ? 1 : 0;
            scrollRef.current.scrollLeft = previousScrollLeft + (LoadMoreDateCount - adjustable) * ItemWidth;
          }
        });
        return [].concat(dateArray, _toConsumableArray(prev));
      });
    }
  }, [selectedDate]);
  var handleLoadAfter = React__default.useCallback(function () {
    setDates(function (prev) {
      var lastIndexDate = prev[prev.length - 1];
      var dateArray = [];
      for (var i = 1; i <= LoadMoreDateCount; i++) {
        var date = new Date(lastIndexDate);
        date.setDate(lastIndexDate.getDate() + i);
        dateArray.push(date);
      }
      return [].concat(_toConsumableArray(prev), dateArray);
    });
  }, []);
  // 날짜 배열 생성
  React__default.useEffect(function () {
    var today = new Date();
    var dateArray = [];
    for (var i = -LoadMoreDateCount; i <= LoadMoreDateCount; i++) {
      var date = new Date();
      date.setDate(today.getDate() + i);
      dateArray.push(date);
    }
    setDates(dateArray);
  }, []);
  // 초기 스크롤 위치 설정
  React__default.useEffect(function () {
    if (dates.length > 0 && scrollRef.current && !isInitialized) {
      var containerWidth = scrollRef.current.clientWidth;
      var centerIndex = dates.length / 2; // 오늘 날짜의 인덱스 (14일 전부터 시작했으므로)
      var leftSideLoaderWidth = innerWidth * 0.5;
      // 스크롤 위치 계산: ((좌측불러오기 공간) + (전체 아이템 너비 * 중앙 인덱스) - (컨테이너 너비 / 2) )
      var scrollPosition = leftSideLoaderWidth + ItemWidth * centerIndex - Math.round(containerWidth / 2);
      scrollRef.current.scrollTo({
        left: scrollPosition,
        behavior: "smooth"
      });
      setIsInitialized(true);
      handleScroll();
    }
  }, [dates, isInitialized]);
  return jsx(Container, {
    children: jsxs(ScrollContainer, {
      ref: scrollRef,
      onScroll: handleScroll,
      children: [jsx(LoadMoreContainer, {
        "$position": "left",
        onClick: handleLoadBefore,
        children: jsxs(LoadMoreChip, {
          children: [jsx("span", {
            children: "2 weeks"
          }), jsx(PlusIcon, {})]
        })
      }, "loadMore-left"), dates.filter(Boolean).map(function (date) {
        var dateStr = getLocalYYYYMMDD(date);
        var isSelected = selectedDate.toDateString() === date.toDateString();
        var hasEvent = Boolean(overviewEventOnCalendar[dateStr]);
        return DateItemCreator({
          date: date,
          isSelected: isSelected,
          hasEvent: hasEvent
        });
      }), jsx(LoadMoreContainer, {
        "$position": "right",
        onClick: handleLoadAfter,
        children: jsxs(LoadMoreChip, {
          children: [jsx("span", {
            children: "2 weeks"
          }), jsx(PlusIcon, {})]
        })
      }, "loadMore-right")]
    })
  });
};

export { DayAndWeekIndicator };
